export default __webpack_public_path__ + "static/media/gplay-btn.bfe92a8e.png";